export default "__VITE_ASSET__DxTk9nso__"